// Reuse the checked deferred-video, error, motion and visibility lifecycle.
await customElements.whenDefined('sterling-collection-video');
const SterlingBackgroundVideo = customElements.get('sterling-collection-video');

class SterlingBattlefieldVideo extends SterlingBackgroundVideo {
  connectedCallback() {
    this.panel = this.closest('[data-sterling-panel]');
    this.hovering = false;
    this.touchActive = false;
    super.connectedCallback();
    if (!this.panel || !this.toggle) return;
    const { signal } = this.abortController;
    this.panel.addEventListener('pointerenter', (event) => {
      if (event.pointerType !== 'mouse') return;
      this.hovering = true;
      this.sync();
    }, { signal });
    this.panel.addEventListener('pointerleave', (event) => {
      if (event.pointerType !== 'mouse') return;
      this.hovering = false;
      this.sync();
    }, { signal });
    this.panel.addEventListener('focusin', () => this.sync(), { signal });
    this.panel.addEventListener('focusout', () => queueMicrotask(() => {
      if (this.isConnected) this.sync();
    }), { signal });
    this.panel.querySelector('[data-sterling-panel-toggle]')?.addEventListener('click', () => {
      this.touchActive = this.panel.classList.contains('is-active');
      this.sync();
    }, { signal });
    this.panelObserver = new MutationObserver(() => this.sync());
    this.panelObserver.observe(this.panel, { attributes: true, attributeFilter: ['class'] });
  }

  shouldPlay() {
    const focused = this.panel?.contains(document.activeElement) && document.activeElement?.matches(':focus-visible');
    return super.shouldPlay() && this.panel?.classList.contains('is-active') &&
      (this.hovering || focused || this.touchActive || this.userStarted);
  }

  disconnectedCallback() {
    this.panelObserver?.disconnect();
    super.disconnectedCallback();
  }
}

if (!customElements.get('sterling-battlefield-video')) {
  customElements.define('sterling-battlefield-video', SterlingBattlefieldVideo);
}
